renderPlanTemplate